import { get } from 'lodash'
import bus from '@/utils/eventBus'

export default function () {
  const patientId = get(this.$route, 'query.dependent_id', null)

  if (patientId) {
    this.agenda.patient.id = patientId
  } else {
    this.agenda.patient.id = this.user.id
    this.agenda.patient.label = this.user.name
  }

  // Pegando a latitude e longitude atraves dos dados informados pelo
  bus.$on('real-location', values => {
    if (values.longitude) {
      this.setLocationByGeoLocationAll(values.longitude, values.latitude)
    }
  })

  // Selecionando todas a especialidades
  this.getAllSepcialities()

  // this.validarStatusAgenda()
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/mounted.js